import React from "react";

interface ViewIconProps {
  // isDisabled?: boolean;
  color: string;
}

const DownloadIcon: React.FC<ViewIconProps> = ({ color }) => {
  // const fillColor = isDisabled ? "#92C4DB" : "#0075AA";
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="17"
      viewBox="0 0 14 17"
      fill={color}
    >
      <path d="M0 17H14V15H0V17ZM14 6H10V0H4V6H0L7 13L14 6Z" fill={color} />
    </svg>
  );
};

export default DownloadIcon;
